export default `<div style="margin-top:1em;">



    <p><strong>FutureX's Perspective</strong></p>

    <p class="img"> <img src="/storage/app/media/uploaded-files/Picture2.jpg" style="width: 340px;" class="fr-fic fr-dib"
            data-result="success"></p>

    <p>Cynthia Zhang, Founding Partner of FutureX Capital, expressed the firm's satisfaction in participating in the
        Pre-A round financing of Lotus Technology in 2021. This move was made after a detailed analysis of the rapidly
        expanding global electric vehicle market, particularly the luxury and super-luxury electric vehicle segments.
        FutureX Capital identified a significant market opportunity and decided to invest in the Lotus Technology. Since
        its inception, FutureX Capital has designated electric vehicles as one of its primary investment areas. It has
        adopted a comprehensive investment strategy, encompassing high-end electric passenger vehicles, integrated
        commercial electric vehicles, and upstream technologies in the ADAS system. This includes areas like ADAS
        computing chips and L2-L3 level algorithm development.</p>



    <p><strong>About Lotus</strong></p>

    <p>Lotus, a world-class rare supercar brand with a long history and global fame, has demonstrated its unparalleled
        technical and design capabilities through outstanding performances in numerous international competitions. With
        the support of Geely Group, Lotus has introduced top-tier R&amp;D and management teams, fully transforming into
        an electric vehicle manufacturer. This strategic decision has given it a unique position in the competitive
        domestic electric vehicle market, creating a competitive advantage through differentiation. Moreover, FutureX
        Capital believes that with the comprehensive support and synergy of its two major shareholders, Geely Automobile
        and NIO, Lotus has received strong momentum in vehicle development, autonomous driving technology, supply chain
        management, production efficiency, and market marketing. This has not only accelerated Lotus's transformation
        towards electrification but also paved the way for the future of high-end electric driving experiences.</p>

    <p>Cynthia Zhang noted that what the team saw in Lotus was not just the transformation of a brand with a glorious
        history but also a profound insight and forward-looking layout for the future high-end electric vehicle market.
        We are convinced that as the electric vehicle market continues to expand and consumer demand for high-end
        electric driving experiences grows, Lotus's strategic transformation will position it as a leader in the global
        electric vehicle competition. Lotus's electrification transformation will showcase the significant advantages of
        China's electric vehicle supply chain, becoming a successful example of the combination of an internationally
        renowned brand and local supply chain advantages. FutureX Capital is confident in Lotus's future and looks
        forward to it creating more milestones in the new energy vehicle field.</p>



    <p><strong>Lotus's brand-wide electrification transformation marks the beginning of a new era in high-end electric
            driving.</strong></p>

    <p>As Lotus's first all-electric supercar SUV, the Eletre carries the essence and brand DNA of Lotus's 74 years of
        sports car design and engineering. Unveiled globally at the end of March this year, the Eletre is a product of
        the integration of experiences from teams in the UK, Germany, and China. It incorporates the design essence of
        the fuel sports car Emira and the powerful performance of the all-electric supercar Evija, redefining what an
        all-electric supercar SUV is. Equipped with cutting-edge intelligent hardware and top-tier software
        technologies, the Eletre represents a new ecosystem of future intelligent technologies. Its standard
        configuration includes 34 high-performance sensors, including the world's first foldable LiDAR, achieving
        centimeter-level quintuple sensing accuracy and ensuring comprehensive coverage. Moreover, equipped with two
        NVIDIA Orin-X chips, with a total computing power of 508 TOPS (trillion operations per second), the Eletre
        offers aviation-grade redundancy and powerful computing support, bringing an unprecedented new driving
        experience to drivers.</p>

    <p class="img"> <img data-fr-image-pasted="true" src="https://futurexcapital.com/storage/app/media/uploaded-files/Picture3.png"
            data-result="success" class="fr-fic fr-dii"></p>

    <p>Lotus's first all-electric SUV Eletre was globally launched in March 2022 and went on sale in October 2022; First
        all-electric supercar Emeya would go on in January 2024;</p>



    <p><strong>"Brand of the Year" at the 2024 Carwow Awards</strong></p>

    <p>Lotus has been internationally recognized for its achievements in electric vehicle innovation, being named "Brand
        of the Year" at the 2024 Carwow Awards. Carwow praised Lotus for its automotive innovation across all its
        electric vehicles, specifically highlighting the Eletre as an impressive electric SUV and Emira as the peak of
        Lotus. This honor is a testament to Lotus's revival and its commitment to embracing the future while respecting
        its rich tradition of performance and innovation.</p>

    <p class="img"> <img src="/storage/app/media/uploaded-files/Picture4.png" style="width: 427px;" class="fr-fic fr-dib"
            data-result="success"></p>



    <p><strong>Lotus's Wuhan Global Intelligent Factory marks a significant milestone in Lotus's full transition towards
            electrification and intelligence.</strong></p>

    <p>Spanning over 1,526 acres, this modern factory not only signifies the advanced technology of Lotus electric
        vehicles but also highlights its globally leading intelligent manufacturing capabilities. Completed on July 15,
        2022, with a designed annual production capacity of approximately 150,000 units, the first all-electric supercar
        Eletre produced here was delivered to the Chinese market in March 2023, followed by global sales. Employing
        digital twin technology for planning, design, and construction, the factory showcases four major features:
        intelligent production, digital lean manufacturing, high flexibility, and green manufacturing, establishing
        Lotus's exceptional quality standards in manufacturing million-level all-electric models. Through this factory,
        Lotus not only inherits its extreme performance and excellent craftsmanship in manufacturing supercars but also
        keeps pace with the industry trend of intelligent manufacturing, demonstrating the brand's leading position in
        the global new energy vehicle market.</p>

    <p class="img"> <img src="/storage/app/media/uploaded-files/Picture5.png" style="width: 450px;" class="fr-fic fr-dib"
            data-result="success"></p>

    <p>As Lotus continues to expand its global footprint, opening new experience centers and entering new markets, it
        remains committed to delivering exciting driving experiences, innovative technologies, and sustainable mobility
        solutions. The company's vision of becoming a global performance brand is smoothly progressing, with Lotus
        leading in the electrification wave of the automotive industry.</p>

</div>`;
